import React, { useState } from 'react';
import styles from './MultipleSelection.module.css'; // Import CSS module for styling

//props.title
//props.optionList
//props.onToggle
//props.selectedOptions


const MultipleSelection = (props) => {
    // const [selectedOptions, setSelectedOptions] = useState([]);

    // const toggleOption = (id) => {
    //     console.log(id)
    //     if (selectedOptions.includes(id)) {
    //         setSelectedOptions(selectedOptions.filter(optionId => optionId !== id));
    //     } else {
    //         setSelectedOptions([...selectedOptions, id]);
    //     }
    // };

    let optionArr = []
    if (props.optionList)
        optionArr = props.optionList.map(option => (
            <li key={option.id} className={styles.listItem}>
                <div className={styles.checkbox}>
                    <input
                        id={option.id + 'checkbox'}
                        type="checkbox"
                        checked={props.selectedOptions.includes(option.value)}
                        onChange={() => props.onToggle(option.selectedObj || option.id)}
                    />
                    <label htmlFor={option.id + 'checkbox'} className={styles.checkmark}></label>
                </div>
                <label htmlFor={option.id + 'checkbox'} className={`${styles.label}`}>{option.label}</label>
            </li>
        ))

    return (
        <article className={styles['checkbox-container']}>
            <h3 className={styles['checkbox-title']}>{props.title}</h3>
            <div className={styles.container}>
                <ul className={styles.list}>
                    {optionArr}
                </ul>
            </div>
        </article>
    );
};

export default MultipleSelection;
